"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsTableReducer = exports.defaultProductsTableState = void 0;
const table_config_1 = require("../../shared/table-config");
const attributes_1 = require("../../../constants/attributes");
exports.defaultProductsTableState = Object.assign(Object.assign({}, table_config_1.defaultTableState), { 
    // Default sorting by product SKU/ID
    sort: {
        key: attributes_1.CustomProductAttributes.ExternalId,
        direction: 0 /* SortDirection.Ascending */,
        default: true,
    } });
const productsTableReducer = (
// eslint-disable-next-line default-param-last
state = exports.defaultProductsTableState, action) => {
    if (action.type.includes(table_config_1.TableEntityPrefix.Products)) {
        const productsTableState = (0, table_config_1.createTableReducer)(table_config_1.TableEntityPrefix.Products, exports.defaultProductsTableState)(state, action);
        return productsTableState;
    }
    return state;
};
exports.productsTableReducer = productsTableReducer;
